import * as React from 'react';
import { Messages } from '../../codegen/Localize';
import { DraftType } from '../../ts/ServerApi/types/IDraft';
import { DraftStyles } from '../styles/DraftStyles';

export interface DraftTagsProps {
  readonly draft?: DraftType;
}

interface DraftTagProps {
  readonly draftTag: string;
}

export class DraftTags extends React.Component<DraftTagsProps>{
  private createTags() {
    // if a draft doesn't have a parentContent then it's a unpublished draft
    let draftsTags: Array<string> = [Messages.draftTag()];
    !this.props.draft.parentContentTRI && draftsTags.push(Messages.draftUnpublishedTag());
    return draftsTags;
  }

  public render() {
    let draftTags = this.createTags();
    let draftTagFragments = draftTags.map((draftTag: string, draftIndex: number) => {
      return (
        <React.Fragment key={`draft-tag-${draftIndex}`}>
          <DraftTag draftTag={draftTag} > </DraftTag>
        </React.Fragment>
      );
    });
    return (
      <div className={DraftStyles.DraftTagsContainer}> {...draftTagFragments} </div>
    );
  }
}

export class DraftTag extends React.Component<DraftTagProps>{
  public render() {
    return (
      <div className={DraftStyles.DraftTag}>{this.props.draftTag}</div>
    );
  }
}
